import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const SHORT = /(facebook\.com\/(share|reel\/share)\/|fb\.watch\/)/;
const cache = new Map();

// Facebook "share" links (facebook.com/share/v/...) don't play in Facebook's embedded player, so ask the server for the full link once.
export const useVideoUrl = (url = "") => {
  const short = SHORT.test(url);
  const [out, setOut] = useState(() => (short ? cache.get(url) || "" : url));
  useEffect(() => {
    if (!short) { setOut(url); return undefined; }
    if (cache.has(url)) { setOut(cache.get(url)); return undefined; }
    let live = true;
    api.get("/media/resolve", { params: { url } })
      .then((r) => { const u = r.data?.url || url; cache.set(url, u); if (live) setOut(u); })
      .catch(() => { if (live) setOut(url); });
    return () => { live = false; };
  }, [url, short]);
  return out;
};
